export const en = {
  headerTitle: 'Contact Us',
  headerSubtitle: 'Get in touch with our team to learn more about our solutions',
  infoTitle: 'Our Information',
  infoIntro: 'Feel free to reach out to us through any of these channels:',
  addressLabel: 'Address',
  address: '#160, St. 10, Borey Peng Heng,Sangkat Prey Vaeng, Dangkao, Phnom Penh, Cambodia',
  phoneLabel: 'Phone',
  phone: '+855 010 440 600',
  emailLabel: 'Email',
  emailPrimary: 'info@akas.co',
  emailSecondary: 'support@akas.co',
  businessHoursLabel: 'Business Hours',
  businessHours: 'Monday - Friday: 8:00 AM - 5:00 PM',
  form: {
    title: 'Send us a Message',
    intro: "Fill out the form below and we'll get back to you as soon as possible.",
    successTitle: 'Thank you for contacting us!',
    successText: 'We have received your message and will get back to you shortly.',
    clickToSendAnother: 'Click to send another message',
    fullName: 'Full Name*',
    emailAddress: 'Email Address',
    phoneNumber: 'Phone Number*',
    companyName: 'Company Name',
    companyIndustry: 'Industry',
    companySize: 'Number of Employees',
    subject: 'Subject*',
    message: 'Message*',
    sending: 'Sending...',
    submit: 'Send Message',
  },
  formError: 'Failed to send email. Please try again later.',
  // map: {
  //   title: 'Visit Our Office',
  //   location: 'Office Location',
  // },
};

export type Copy = typeof en;

export const km: Copy = {
  headerTitle: 'ទំនាក់ទំនងយើង',
  headerSubtitle: 'ទាក់ទងក្រុមការងាររបស់យើង ដើម្បីស្វែងយល់បន្ថែមអំពីដំណោះស្រាយរបស់យើង',
  infoTitle: 'ព័ត៌មានទំនាក់ទំនង',
  infoIntro: 'សូមទាក់ទងយើងតាមវិធីណាមួយខាងក្រោម៖',
  addressLabel: 'អាសយដ្ឋាន',
  address: '#160, ផ្លូវលេខ 10, បុរីប៉េងហេង, សង្កាត់ព្រៃវែង, ខណ្ឌដង្កោ, ភ្នំពេញ, កម្ពុជា',
  phoneLabel: 'លេខទូរស័ព្ទ',
  phone: '+855 010 440 600',
  emailLabel: 'អ៊ីមែល',
  emailPrimary: 'info@akas.co',
  emailSecondary: 'support@akas.co',
  businessHoursLabel: 'ម៉ោងធ្វើការ',
  businessHours: 'ថ្ងៃចន្ទ - ថ្ងៃសុក្រ៖ ៨:០០ ព្រឹក - ៥:០០ ល្ងាច',
  form: {
    title: 'ផ្ញើសារមកយើង',
    intro: 'បំពេញទម្រង់ខាងក្រោម ហើយយើងនឹងឆ្លើយតបឱ្យបានឆាប់តាមដែលអាចធ្វើបាន។',
    successTitle: 'អរគុណដែលបានទាក់ទងយើង!',
    successText: 'យើងបានទទួលសាររបស់អ្នករួចរាល់ ហើយនឹងឆ្លើយតបមកអ្នកឱ្យបានឆាប់។',
    clickToSendAnother: 'ចុចដើម្បីផ្ញើសារថ្មី',
    fullName: 'ឈ្មោះពេញ*',
    emailAddress: 'អ៊ីមែល',
    phoneNumber: 'លេខទូរស័ព្ទ*',
    companyName: 'ឈ្មោះក្រុមហ៊ុន',
    companyIndustry: 'ឧស្សាហកម្ម',
    companySize: 'ចំនួនបុគ្គលិក',
    subject: 'ប្រធានបទ*',
    message: 'សារ*',
    sending: 'កំពុងផ្ញើ...',
    submit: 'ផ្ញើសារ',
  },
  formError: 'ផ្ញើអ៊ីមែលមិនបានជោគជ័យ។ សូមព្យាយាមម្តងទៀតពេលក្រោយ។',
  // map: {
  //   title: 'មកទស្សនាការិយាល័យរបស់យើង',
  //   location: 'ទីតាំងការិយាល័យ',
  // },
};
